import { Grid, Button, Box } from '@simplywallst/ui-core';
import CrossSolid from '@simplywallst/ui-core/icons/CrossSolid';
import ChevronRightSmallSolid from '@simplywallst/ui-core/icons/ChevronRightSmallSolid';
import { pluralise } from '@/utilities/pluralise';

type Props = {
  isLoading?: boolean;
  newCompaniesCount: number | null;
  value: boolean;
  onChange: (returnRecentCompaniesOnly: boolean) => void;
};

export const RecentResultsToggle = ({
  isLoading,
  newCompaniesCount,
  value: returnRecentCompaniesOnly,
  onChange,
}: Props) => {
  return (
    <Button
      styleType={returnRecentCompaniesOnly ? 'loud' : 'gentle'}
      onClick={() => onChange(!returnRecentCompaniesOnly)}
      alignIcon="right"
      isLoading={isLoading}
      disabled={isLoading}
      aria-pressed={returnRecentCompaniesOnly}
    >
      <Grid
        display="inline-grid"
        alignItems="center"
        templateColumns="max-content max-content"
        gap="6px"
      >
        <Box
          width="6px"
          height="6px"
          backgroundColor="attention"
          borderRadius="x2"
        />
        {newCompaniesCount ?? 0} new{' '}
        {pluralise(newCompaniesCount, 'company', 'companies')} last 7d
      </Grid>
      {!isLoading && (
        <>
          {returnRecentCompaniesOnly ? (
            <CrossSolid />
          ) : (
            <ChevronRightSmallSolid />
          )}
        </>
      )}
    </Button>
  );
};
